import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactGA from 'react-ga';
import Scroll from 'react-scroll';

import EmotionButton from './EmotionButton';
import Button from './Button';

import { getResult, postResult } from '../utils/result-handler';

const emotions = [
  {
    value: 'happy',
    label: '開心'
  },
  {
    value: 'sad',
    label: '難過'
  },
  {
    value: 'annoyed',
    label: '煩躁'
  },
  {
    value: 'bored',
    label: '無聊'
  }
];

const checkHasSelected = (selected) => {
  const keys = Object.keys(selected);
  if (!keys.length) return false;
  return keys.some(key => selected[key]);
};

class ExtraQuestion extends React.Component {
  state = {
    selected: {},
    hasSelected: false,
    isButtonActive: false
  }

  onConfirm = (e) => {
    const {
      responses,
      addUserExtraResponse,
      createResult,
      history
    } = this.props;

    const { selected } = this.state;

    e.preventDefault();

    const result = getResult(responses);
    const emotion = Object.keys(selected).filter(key => selected[key]);
    emotion.forEach(label => ReactGA.event({
      category: 'Emotion',
      action: 'Answer',
      label
    }));
    createResult(result);
    postResult(responses, emotion);
    addUserExtraResponse(emotion);

    history.push('/tape');
  }

  onClick = (emotion) => {
    this.setState(({ selected }) => {
      const newSelected = {
        ...selected,
        [emotion]: !selected[emotion]
      };
      return {
        selected: newSelected,
        hasSelected: checkHasSelected(newSelected)
      };
    });
    const scroller = Scroll.scroller;
    scroller.scrollTo('anchor', {
      duration: 500,
      delay: 100,
      smooth: true,
      containerID: 'extra-question'
    });
  }

  activateButton = () => {
    this.setState({
      isButtonActive: true
    });
  }

  deactivateButton = () => {
    this.setState({
      isButtonActive: false
    });
  }

  render() {
    const Element = Scroll.Element;
    return (
      <div className="container pos-abs" id="extra-question">
        <div className="row margin-top-xl">
          <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 text-center">
            <div className="dialog dialog-bubble dialog-md horizontal-center">
              <small>(複選)</small>
              <h2 className="margin-no" style={{ marginBottom: '0.35em' }}>以下哪些情緒容易讓妳購物？</h2>
            </div>
          </div>
        </div>
        <div className="row margin-top-md-c">
          {emotions.map(({ value, label }, index) => (
            <div
              key={`choice-${value}`}
              className={classNames(
                'col-xs-5',
                { 'col-xs-offset-1': index % 2 === 0 },
                'col-sm-2',
                { 'col-sm-offset-2': index === 0 },
                { 'col-sm-offset-0': index === 2 },
                { 'text-right': index % 2 === 0 },
                { 'text-left': index % 2 === 1 },
                'text-center-sm'
              )}
            >
              <EmotionButton
                emotion={value}
                display={label}
                onClick={() => this.onClick(value)}
                selected={Boolean(this.state.selected[value])}
              />
            </div>
          ))}
        </div>
        <Element name="anchor" />
        {this.state.hasSelected && (
          <div className="row margin-top-lg">
            <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 text-center">
              <Button
                className={classNames(
                  'btn',
                  'btn-default',
                  'margin-bottom-lg'
                )}
                onClick={this.onConfirm}
              >
                確定
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}


ExtraQuestion.propTypes = {
  responses: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  createResult: PropTypes.func.isRequired,
  addUserExtraResponse: PropTypes.func.isRequired,
  history: PropTypes.shape().isRequired
};

export default ExtraQuestion;



// WEBPACK FOOTER //
// ./app/components/ExtraQuestion.js